import { render } from "./PrepareBatch.vue?vue&type=template&id=69184adc"
import script from "./PrepareBatch.vue?vue&type=script&lang=js"
export * from "./PrepareBatch.vue?vue&type=script&lang=js"
script.render = render

export default script